/**
 * 动态api
 */
export default {
  // 资讯
  newsInfodelete: "/newsInfo/delete", // 删除/{id}
  newsInfoinsert: "/newsInfo/insert", // 新增
  newsInfoselectPage: "/newsInfo/selectPage", // 查询
  newsInfoupdate: "/newsInfo/update", // 修改
  newsInfoupdateStatus: "/newsInfo/updateStatus", // 上下架
  newsInfoselectDetail: "/newsInfo/selectDetail", // 查询详情
}
